import styled from 'styled-components'

export const Container = styled.div`
  margin-bottom: 1.5em;
  font-size: 0.9rem;
`
